import { Camera, Container, vec3, Object3d } from '@beam/core';
import { AssetsManager, GLSCene } from '@beam/engine';

const DEFAULT_QUALITY_MODE = window.innerWidth < 768 ? 'Mobile_Low' : 'Desktop_Medium';
const DEFAULT_PLAY_MODE = 'play';

const PROJECT_URL = `assets/AIRoom/`;
const assetUrl = relativePath => PROJECT_URL + relativePath.replace(/^\/+/, '');

const NUM_SCROLL_VH = 4;

let diff = vec3.create();
let cameraDir = vec3.create();

export default class PageExperience extends HTMLElement {

    constructor() {
        super();
        this.update = this.update.bind(this);
        this.resize = this.resize.bind(this);
        this.cameraProgress = 0;
        this.cameraRotationY = 0;
        this._pathPos = vec3.create();
        this._pathAhead = vec3.create();
        this._prevCamPos = vec3.create();
        this._camVelocity = vec3.create();
        this._prevTheta = 0;
        this._prevPhi = 0;
        this._smoothedTheta = Math.PI;
        this.pvs = {enabled: true, byPosition: null, lastIndex: -1};
    
        
        this._prevCameraProgress = 0;
        this._pathRotationInitialized = false;
        this._resetCameraRotation = false;
    }

    // resetCameraPathRotation() {
    //     this.cameraRotationY = 0;
    //     // this._pathRotationInitialized = false;
    // }

    resetCameraPathRotation() {
        const TWO_PI = Math.PI * 2;
        this.cameraRotationY = ((this.cameraRotationY + Math.PI) % TWO_PI + TWO_PI) % TWO_PI - Math.PI;
        this._resetCameraRotation = true;
    }



    async load() {

        let currentQualityMode = DEFAULT_QUALITY_MODE;
        this.currentProfile = currentQualityMode;

        this.glScene  = document.querySelector('gl-scene');
        const project = await this.glScene.loadProject(PROJECT_URL);

        // const defaultLevelName = project.gameConfig?.DefaultLevel;
        const levelParam       = new URLSearchParams(window.location.search).get('level');
        const defaultLevelName = 'assets/maps/' + (levelParam !== null ? levelParam : 'Server_03'); 

        this.levelAsset = await AssetsManager?.Get()?.LoadAssetByPath(defaultLevelName);

        this.level = this.levelAsset.level; 
        this.scene = this.level.scene;

        const views = [];

        let w = window.innerWidth;
        let h = window.innerHeight;
        let x = 0;
        let y = 0;

        this.playerCamera = new Camera({
            aspect:          w/h,
            far:             2000000,
            near:            10,
            fov:             45,
            moveSpeed:       100,
            type:            'perspective',
            firstPerson:     true, 
            // tilt:            true,
            wheelSpeed:      0.1,
            offset:          [0,0,0],
            position:        [0,0,0],
            frustum:         true,
            useCollision:    false,
            followTerrain:   false,
            theta:           Math.PI,
            preventKeyboard: true,
            preventDefault: true,
        });
        this.playerCamera.lookAt = vec3.create()
        this.playerCamera.aspect  = w/h
        this.playerCamera.updateProjectionMatrix();


        this.debugCamera = new Camera({
            aspect:         w/h,
            far:            2000000,
            near:           10,
            fov:            45,
            moveSpeed:      100,
            type:           'perspective',
            firstPerson:   true, 
            wheelSpeed:     0.1,
            offset:        [0,0,0],
            position:      [0,100,0],
            frustum:       true,
            useCollision:  false,
            followTerrain: false,
            theta: Math.PI,
        });
        this.debugCamera.lookAt = vec3.create()
        this.debugCamera.aspect  = w/h
        this.debugCamera.updateProjectionMatrix()

        views.push({
            camera: this.playerCamera,
            rect:   [0,0,1,1]
        });
        this.glScene.createSceneRenderContext(this.levelAsset.name+'_play', {
            scene: this.scene, 
            views, 
            offset:     [x, y],
            resolution: [w, h],
            flags: {
                UseLightmaps: true,
            }
        });
        this.glScene.showSceneRenderContext(this.levelAsset.name+'_play');
        this.glScene.setLevel(this.levelAsset.level);
        this.glScene.updateProfile( DEFAULT_QUALITY_MODE ); 

        this.sceneRenderContext = this.glScene?.getSceneRenderContext?.(this.levelAsset.name+'_play');

        // const $qualityModebuttons = document.querySelectorAll('[data-quality-button]');
        // $qualityModebuttons?.forEach((el) => {
        //     let quality = el.getAttribute('data-quality');
        //     el.addEventListener('click', e => {
        //         glScene.updateProfile( quality ); 
        //         currentQualityMode = quality;
        //         window.dispatchEvent(new Event('resize'));
        //         glScene?.resize();
        //         $qualityModebuttons?.forEach(($playModebutton) => {
        //             $playModebutton.classList.remove('is-selected')
        //         });
        //         el.classList.add('is-selected');
        //     });
        // });

        // // COPIED PATCH FROM Dan's version
        // // We shoudl moved this to the engine enveutally
        // {
        //     const gl = this.glScene.gl;
        //     let currentUnit = -1;
        //     const bound   = new Map();
        //     const oActive = gl.activeTexture.bind(gl);
        //     const oBind   = gl.bindTexture.bind(gl);
        //     const oDelete = gl.deleteTexture.bind(gl);
        //     gl.activeTexture = unit => {
        //         if (unit !== currentUnit) { 
        //             currentUnit = unit; 
        //             oActive(unit); 
        //         }
        //     };
        //     gl.bindTexture = (target, texture) => {
        //         const key = currentUnit * 100000 + target;
        //         if (bound.get(key) !== texture) { 
        //             bound.set(key, texture); 
        //             oBind(target, texture); 
        //         }
        //     };
        //     gl.deleteTexture = texture => {
        //         for (const [k, v] of bound) { 
        //             if (v === texture) {
        //                 bound.delete(k); 
        //             }
        //         }
        //         return oDelete(texture);
        //     };
        // }

        (async () => {
            try {
                const json = await (await fetch(assetUrl('build/levels/Server_03/pvs.json'))).json();
                this.pvs.byPosition = json.visible.map(list => new Set(list));
                const avg = Math.round(json.visible.reduce((a, v) => a + v.length, 0) / json.visible.length);
            }
            catch {
                console.log('No baked PVS (run /?bakepvs) — using runtime occlusion queries');
            }
        })();

        this.cameraPath = await this.loadCameraPath(assetUrl('build/levels/Server_03/POI.glb'));


        this.resize();
        
    }

    getUIPositions() {
        let screenPositions = {}
        let uiArr =[
            {"id":"POI_0", "position": [1980, 490, -1300]},
            {"id":"POI_1", "position": [2610, 150, -1040]},
            {"id":"POI_2", "position": [1370, 130, 260]},
            {"id":"POI_3", "position": [-3300, 150, 1690]},
            {"id":"POI_4", "position": [5940, 190, 350]},
            {"id":"POI_5", "position": [1370, 170, 1030]},
            {"id":"POI_6", "position": [1410, 150, 1620]},
            {"id":"POI_7", "position": [2260, 240, -1390]},
            {"id":"POI_8", "position": [5820, 190, 4000], "distance": 4000},
        ];
        let p = vec3.create();
        if (this.playerCamera) {
            uiArr?.forEach((uiEl, i)=>{
                vec3.set(p, uiEl.position[0], uiEl.position[1], uiEl.position[2]);
                vec3.copy( diff, p );
                vec3.subtract( diff, diff, [ this.playerCamera.worldMatrix[12], this.playerCamera.worldMatrix[13], this.playerCamera.worldMatrix[14] ] )
                let dist = vec3.length( diff )
                vec3.normalize(diff, diff);
                vec3.copy(cameraDir, this.playerCamera.lookAt);
                vec3.subtract(cameraDir, cameraDir, [ this.playerCamera.worldMatrix[12], this.playerCamera.worldMatrix[13], this.playerCamera.worldMatrix[14] ]);
                vec3.normalize(cameraDir, cameraDir);
                if (vec3.dot( cameraDir, diff ) > 0) {
                    vec3.transformMat4(p, p, this.playerCamera.inverseWorldMatrix );
                    vec3.transformMat4(p, p, this.playerCamera.projectionMatrix );
                    let x = window.innerWidth * .5 + p[0]*window.innerWidth*.5
                    let y = window.innerHeight * .5 + p[1]*-1*window.innerHeight*.5
                    screenPositions[uiEl.id] = [x,y, Math.abs(dist), uiEl.distance || -1];
                }
                else {
                    screenPositions[uiEl.id] = [-window.innerWidth,0, -1, uiEl.distance || -1];
                }
            });
        }
        return screenPositions;
    }

    applyPVS(progress) {
        if (!this.pvs.byPosition) {
            return;
        }
        if (!this.pvs.enabled) { 
            this.sceneRenderContext.clearVisibilitySet(); 
            return; 
        }
        const n = this.pvs.byPosition.length;
        const index = Math.max(0, Math.min(n - 2, Math.floor(Math.max(0, Math.min(1, progress)) * (n - 1))));
        if (index !== this.pvs.lastIndex) {
            this.pvs.lastIndex = index;
            const merged = new Set(this.pvs.byPosition[index]);
            for (const key of this.pvs.byPosition[index + 1]) merged.add(key);
            this.sceneRenderContext.setVisibilitySet(merged);
        }
    }

    async loadCameraPath(url) {
        const CAMERA_EYE_HEIGHT = 170;
        try {
            const buf = await (await fetch(url)).arrayBuffer();
            const dv = new DataView(buf);
            if (dv.getUint32(0, true) !== 0x46546C67) throw new Error('not a GLB');
            const jsonLen = dv.getUint32(12, true);
            const json = JSON.parse(new TextDecoder().decode(new Uint8Array(buf, 20, jsonLen)));

            // compose world-space translations through the node hierarchy (UE m → cm)
            const nodes = json.nodes || [];
            const dots = [];
            const walk = (index, parentPos) => {
                const node = nodes[index];
                if (!node) return;
                const t = node.translation || [0, 0, 0];
                const world = [parentPos[0] + t[0], parentPos[1] + t[1], parentPos[2] + t[2]];
                if (node.translation) {
                    dots.push({name: node.name || String(index), pos: [world[0] * 100, world[1] * 100 + CAMERA_EYE_HEIGHT, world[2] * 100]});
                }
                node.children?.forEach(c => walk(c, world));
            };
            (json.scenes?.[json.scene ?? 0]?.nodes || []).forEach(i => walk(i, [0, 0, 0]));
            if (dots.length < 2) throw new Error('not enough POI dots');

            // order: begin at 'start', then greedily chain to the nearest unused dot
            const distSq = (a, b) => (a[0] - b[0]) ** 2 + (a[1] - b[1]) ** 2 + (a[2] - b[2]) ** 2;
            const startIndex = Math.max(0, dots.findIndex(d => /start/i.test(d.name)));
            const remaining = [...dots];
            const ordered = remaining.splice(startIndex, 1);
            while (remaining.length) {
                const last = ordered[ordered.length - 1].pos;
                let bestI = 0, bestD = Infinity;
                remaining.forEach((d, i) => { const dd = distSq(d.pos, last); if (dd < bestD) { bestD = dd; bestI = i; } });
                ordered.push(remaining.splice(bestI, 1)[0]);
            }

            // arc-length table over the polyline for uniform-speed sampling
            const pts = ordered.map(d => d.pos);
            const cumulative = [0];
            for (let i = 1; i < pts.length; i++) {
                const dx = pts[i][0] - pts[i - 1][0], dy = pts[i][1] - pts[i - 1][1], dz = pts[i][2] - pts[i - 1][2];
                cumulative.push(cumulative[i - 1] + Math.sqrt(dx * dx + dy * dy + dz * dz));
            }
            const totalLength = cumulative[cumulative.length - 1];
            if (!totalLength) throw new Error('degenerate path');

            return {
                points: pts,
                totalLength,
                sample(t, out) {
                    const target = Math.max(0, Math.min(1, t)) * totalLength;
                    let i = 1;
                    while (i < cumulative.length - 1 && cumulative[i] < target) i++;
                    const segLen = cumulative[i] - cumulative[i - 1] || 1;
                    const f = (target - cumulative[i - 1]) / segLen;
                    out[0] = pts[i - 1][0] + (pts[i][0] - pts[i - 1][0]) * f;
                    out[1] = pts[i - 1][1] + (pts[i][1] - pts[i - 1][1]) * f;
                    out[2] = pts[i - 1][2] + (pts[i][2] - pts[i - 1][2]) * f;
                    return out;
                },
            };
        }
        catch (e) {
            console.warn('POI camera path unavailable, falling back to linear rail:', e.message);
            return null;
        }
    }

    resize() {
        if ( this.playerCamera ) {
            this.playerCamera.aspect = window.innerWidth / window.innerHeight
            this.playerCamera.updateProjectionMatrix();
        }
        if (this.debugCamera) {
            this.debugCamera.aspect = window.innerWidth / window.innerHeight
            this.debugCamera.updateProjectionMatrix();
        }
        if (this.levelAsset) {
            this.isResizing = true;
                clearTimeout(this.resizeGLTimer);
                this.resizeGLTimer = setTimeout(()=>{
                const sceneRenderContext = this.glScene?.getSceneRenderContext?.(this.levelAsset.name+'_play');
                if (sceneRenderContext) {
                    sceneRenderContext.offset = [0, 0];
                    sceneRenderContext.resize(window.innerWidth, window.innerHeight);
                    requestAnimationFrame(()=>{
                        requestAnimationFrame(()=>{
                            this.isResizing = false;
                        });
                    });
                }
            }, 1000);
        }
        this.glScene?.resize();
    }

    update() {
        if (this.playerCamera) {

            if (this.cameraPath) {
                this.cameraPath.sample(this.cameraProgress, this._pathPos);
                this.playerCamera.offset[0] = this._pathPos[0];
                this.playerCamera.offset[1] = this._pathPos[1];
                this.playerCamera.offset[2] = this._pathPos[2];
                this.cameraPath.sample(this.cameraProgress + 0.02, this._pathAhead);
                const dx = this._pathAhead[0] - this._pathPos[0];
                const dy = this._pathAhead[1] - this._pathPos[1];
                const dz = this._pathAhead[2] - this._pathPos[2];

                const isScrolling = Math.abs(this.cameraProgress - this._prevCameraProgress) > 0.000001;
                this._prevCameraProgress = this.cameraProgress;
                if (dx * dx + dz * dz > 1) {
                    const targetTheta = Math.atan2(dx, dz);
                    const targetPhi = -Math.atan2(dy, Math.sqrt(dx * dx + dz * dz));
                    if (!this._pathRotationInitialized) {
                        this.playerCamera.theta = targetTheta;
                        this.playerCamera.currTheta = targetTheta;
                        this.playerCamera.phi = targetPhi;
                        this.playerCamera.currPhi = targetPhi;
                        this._pathRotationInitialized = true;
                    }
                    else if (isScrolling) {
                        let delta = targetTheta - this.playerCamera.theta;
                        while (delta > Math.PI) delta -= Math.PI * 2;
                        while (delta < -Math.PI) delta += Math.PI * 2;
                        this.playerCamera.theta += delta * 0.05;
                        this.playerCamera.phi += (targetPhi - this.playerCamera.phi) * 0.05;
                    }
                }
            }
            else {
                const startX = -3000;
                const endX   = 7000;
                this.playerCamera.offset[2] = 1790;
                this.playerCamera.offset[1] = 180;
                this.playerCamera.offset[0] = startX + (endX - startX) * this.cameraProgress;
            }
    

            if (this._resetCameraRotation) {
                this.cameraRotationY += (0 - this.cameraRotationY) * 0.05;
                if (Math.abs(this.cameraRotationY) < 0.001) {
                    this.cameraRotationY = 0;
                    this._resetCameraRotation = false;
                }
            }

            // Keyboard controlled rotation
            this.playerCamera.extraTheta = this.cameraRotationY;


            const activeCamera = this.playerCamera;
            const camPos = activeCamera.offset;
            this._camVelocity[0] = camPos[0] - this._prevCamPos[0];
            this._camVelocity[1] = camPos[1] - this._prevCamPos[1];
            this._camVelocity[2] = camPos[2] - this._prevCamPos[2];
            vec3.copy(this._prevCamPos, camPos);
            const speedSq = this._camVelocity[0] ** 2 + this._camVelocity[1] ** 2 + this._camVelocity[2] ** 2;
            const turning =
                Math.abs((activeCamera.theta ?? 0) - this._prevTheta) > 0.002 ||
                Math.abs((activeCamera.phi ?? 0) - this._prevPhi) > 0.002;
            this._prevTheta = activeCamera.theta ?? 0;
            this._prevPhi   = activeCamera.phi ?? 0;
            if (this.pvs.byPosition) {
                this.applyPVS(this.cameraProgress);
            }
        }
    }
    setProfile(profile) {
        this.glScene.updateProfile( profile ); 
        this.currentProfile = profile;
    }
    getProfile() {
        return this.currentProfile || DEFAULT_QUALITY_MODE;
    }
    // setCameraProgress(value) {
    //     if (value !== this.cameraProgress) this.cameraRotationY = 0;
    //     this.cameraProgress = value;
    // }
    setCameraProgress(value) {
        this.cameraProgress = value;
    }
    incrementCameraRotationY(value) {
        this._resetCameraRotation = false;
        this.cameraRotationY += value;
    }
}


customElements.define('page-experience', PageExperience);